module.exports = __webpack_public_path__ + "img/simulados-de-revisao.3b05101a.png";